import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";

import moviesReducer from "./features/movies/moviesSlice";
import peopleReducer from "./features/popularPeople/peopleSlice";
import genresReducer from "./common/genres/genresSlice";
import searchReducer from "./common/search/searchSlice";

import rootSaga from "./rootSaga";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    movies: moviesReducer,
    people: peopleReducer,
    genres: genresReducer,
    search: searchReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;
